/**
 * A Ofcs.Cache instance represents a value store for values created by functions.
 *
 *     // instantiate
 *     var cache = new Ofcs.Cache();
 *
 *     // get a cached value
 *     myCachedValue = cache.get('key', function() {
 *         return 'a value';
 *     });
 *
 *     // get another cached value, using scoping and parameters
 *     anotherCachedValue = cache.get('anotherKey', this.generate, scope, argument1, argument2);
 */
export default class Cache {
    cache = new Map();

    /**
     * Returns a cached value. If the value is not been cache it will be created
     * using the callback function.
     *
     *     cache.get('myKey', function() {
         *         return 'myValue';
         *     });
     *
     * @param {string} key Cache key
     * @param {Function} callback Callback to create a new value
     * @param {Object} scope Scope for the callback (Deprecated, use an arrow function instead!)
     *
     * @return {*} cached value
     */
    get(key, callback, scope, ...args) {
        if (!this.has(key)) {
            this.cache.set(key, callback.apply(scope, args));
        }

        return this.cache.get(key);
    }

    /**
     * Returns true if the cache currently contains a value for the given key
     *
     * @param {*} key
     * @return {boolean}
     */
    has(key) {
        return this.cache.has(key);
    }

    /**
     * Remove one cache entry.
     *
     * @param {string} key
     */
    remove(key) {
        this.cache.delete(key);
    }

    /**
     * Clears the cache.
     */
    clear() {
        this.cache.clear();
    }
}
